import { ICartItem } from "common/types/carts";

import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";
import { useCartItemDeleteMutation } from "client/carts/hooks";
import { useCurrentDialog } from "client/common/hooks/stackables";

export type RemoveCartItemDialogProps = {
  cartId: number;
  cartItem: ICartItem;
};

const RemoveCartItemDialog = ({ cartId, cartItem }: RemoveCartItemDialogProps) => {
  const { close } = useCurrentDialog();
  const {
    mutate: deleteCartItem,
    isPending: isLoading,
    error,
  } = useCartItemDeleteMutation(cartId, {
    onSuccess: close,
  });
  return (
    <ConfirmationDialog
      title="Confirm removing item"
      description="Are you sure you want to remove this item from your cart?"
      denyText="No, keep item"
      confirmText="Yes, remove item"
      onConfirm={() => deleteCartItem(cartItem.id)}
      onDeny={close}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default RemoveCartItemDialog;
